class DataSourcesApiRequestModel {
  // #region Props
  idFuente;
  titulo;
  Tipo;
  host;
  puerto;
  idBbdd;
  nombreBbdd;
  bbddActiva;
  descripcion;
  Activo;
  usuario;
  contrasena;
  // #endregion

  constructor(object) {
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key];
        this[key] = element;
      }
    }
  }

  // #region Private methods
  // #endregion
}

export default DataSourcesApiRequestModel;
